'use client'

import { useTranslations } from 'next-intl'

import { Icon, IconComponent } from '@graftcode/design-system'

import { SHARE_FEEDBACK_TEST_IDS } from '@common/common-test-ids.const'

import styles from './ShareFeedback.module.scss'

export function ShareFeedbackSuccess() {
  const t = useTranslations('feedback')

  return (
    <div className={styles.success} data-testid={SHARE_FEEDBACK_TEST_IDS.success} aria-live="polite">
      <div className={styles.successIcon}>
        <IconComponent icon={Icon.CheckmarkRegular} size={24} />
      </div>
      <p className={styles.successTitle}>{t('create.success.title')}</p>
      <p className={styles.successDescription}>{t('create.success.description')}</p>
    </div>
  )
}
